module.exports = __webpack_public_path__ + "asset/bastion--842222.svg";